import DeviceStatusChip from './DeviceStatusChip';
import type { DeviceStatusProps } from './DeviceStatusChip.types';
import getDeviceStatusColor from './DeviceStatusColor.utils';

export type { DeviceStatusProps };

export { DeviceStatusChip, getDeviceStatusColor };
export default DeviceStatusChip;
